export default __webpack_public_path__ + "static/media/redis.237cd656.svg";